import { connect } from 'react-redux';
import AppSnackbar from '../components/app_snackbar/app_snackbar';
import { clearNotification } from '../actions/notifications';

function mapStateToProps({ notifications }) {
  return {
    notification: notifications.currentNotification,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    clearNotification: () => dispatch(clearNotification()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AppSnackbar);



// WEBPACK FOOTER //
// ./src/containers/app_snackbar.js